import Vue from 'vue'
import Router from 'vue-router'
// import Login from '../components/Login.vue'
const Login = () => import(/* webpackChunkName:"login_home_welcome" */ '../components/Login.vue')
// import Home from '../components/Home.vue'
const Home = () => import(/* webpackChunkName:"login_home_welcome" */ '../components/Home.vue')
// import Welcome from '../components/Welcome.vue'
const Fraction = () => import(/* webpackChunkName:"login_home_fraction" */ '../components/management/fraction.vue')

const GroupBooking = () => import(/* webpackChunkName:"login_home_groupBooking" */ '../components/management/groupBooking.vue')

import '../assets/fonts/iconfont.css'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/fraction' },
    { path: '/login', component: Login },
    {
      path: '/home',
      component: Home,
      redirect: '/Fraction',
      children: [
        { path: '/fraction', component: Fraction },
        { path: '/groupBooking', component: GroupBooking }
      ]
    }
  ]
})

// 为路由对象， 添加 beforeEach 导航守卫
// router.beforeEach((to, from, next) => {
//   // to将要访问的路径
//   // from代表从那个路径跳转而来
//   // next是一个函数，表示放行
//   // 如果用户访问的登陆页，直接放行
//   if (to.path === '/login' || to.path === '/fraction') return next()
//   // 从sessionStorage 中获取到保存的token值
//   const tokenStr = window.sessionStorage.getItem('token')
//   // 没有token，强制跳转到登陆页
//   if (!tokenStr) return next('/login')
//   next()
// })

export default router
